import Whitelist from './Whitelist'

export default Whitelist
